








































































































import {Utils} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Prop, Watch} from "vue-property-decorator";
import AfterFetchComponent from "../../base/AfterFetchComponent";

@Component({
  components: {}
})
export default class ShowDocumentsComponents extends AfterFetchComponent {

  @Prop(Array) attachedFiles!: any[]
  @Prop(String) title!: string
  @Prop(Boolean) showDeleteButton!: boolean
  @Prop(Boolean) showDownloadAllDocsButton!: boolean
  @Prop(Boolean) showUnableDownloadButton!: boolean

  private showCheckIfUserSureToDelete: boolean = false;
  private unableToDisplayFile: boolean = false;
  private showSpinner: boolean = true;
  private fileName: string = "";
  private attachmentId: string = "";
  private attachedFileUrl: any = '';


  @Watch('attachedFiles')
  handleInitAttachedFiles() {
    this.showSpinner = false
  }

  base64ToArrayBuffer(data: string) {
    let bString = window.atob(data);
    let bLength = bString.length;
    let bytes = new Uint8Array(bLength);
    for (let i = 0; i < bLength; i++) {
      let ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  fetchAttachedFile(index: number) {
    if (this.attachedFiles[index].mimeType === 'msg' || this.attachedFiles[index].mimeType === 'eml') {
      this.unableToDisplayFile = true
      this.attachmentId = this.attachedFiles[index].id;
      this.fileName = ""
      this.attachedFileUrl = ""
    } else {
      this.unableToDisplayFile = false
      let bufferArray = this.base64ToArrayBuffer(this.attachedFiles[index].file);
      let blobStore = new Blob([bufferArray], {type: this.attachedFiles[index].mimeType});
      this.attachedFileUrl = window.URL.createObjectURL(blobStore);
      this.fileName = this.attachedFiles[index].name;
      this.attachmentId = this.attachedFiles[index].id;
      this.showCheckIfUserSureToDelete = false;
    }
  }

  handleCheckIfUserSureToDelete() {
    this.showCheckIfUserSureToDelete = true
  }

  handleCancelDelete() {
    this.showCheckIfUserSureToDelete = false
  }

  deleteAttachment() {
    this.$emit("deleteDocument", this.attachmentId)
    this.fileName = ""
    this.attachmentId = ""
    this.attachedFileUrl = ""
    this.showCheckIfUserSureToDelete = false
    this.unableToDisplayFile = false
    this.showSpinner = true
  }

  downloadAttachment() {
    this.$emit("downloadDocument", this.attachmentId)
  }

  onDownloadAllDocs() {
    let filesIdList = this.attachedFiles.map((file: any) => file.id);

    this.$emit("downloadAttachmentsAsZipFile", filesIdList)
  }
}
